// The server's permission codes are authoritative; roles only define data scope.
export function can (user, code) {
  if (!user) return false
  return user.role === 'ADMIN' || (Array.isArray(user.permissionCodes) && user.permissionCodes.includes(code))
}

export function routePermission (route) {
  const name = route.name
  return ({ home: 'HOME_VIEW', users: 'USER_VIEW', classes: 'CLASS_VIEW', cases: 'CASE_VIEW', 'case-workbench': 'CASE_MANAGE',
    'map-templates': 'MAP_VIEW', 'map-template-detail': 'MAP_VIEW', personnel: 'PERSONNEL_VIEW', 'role-standards': 'ROLE_STANDARD_VIEW',
    'network-modules': 'CASE_VIEW', 'network-module-edit': 'CASE_MANAGE', 'network-module-create': 'CASE_MANAGE', 'network-module-ai': 'CASE_MANAGE',
    experiments: 'EXPERIMENT_VIEW', 'task-monitor': 'TASK_MONITOR', assignments: 'EXPERIMENT_VIEW', 'network-run': 'RUN_VIEW', 'policy-run': 'RUN_VIEW',
    reports: 'REPORT_VIEW', notifications: 'NOTIFICATION_VIEW', 'role-guide': 'ROLE_GUIDE_VIEW', logs: 'LOG_VIEW', backups: 'BACKUP_MANAGE', 'role-permissions': 'PLATFORM_ROLE_MANAGE' })[name]
}

// These pages combine the task permission used by the route with an additional
// permission required by the data endpoint they load.
export function additionalRoutePermissions (route) {
  if (route.name !== 'assignments') return []
  const query = route.query || {}
  if (query.view === 'analysis') return ['REPORT_VIEW']
  return query.module === 'policy' ? ['CASE_VIEW'] : []
}

export function menuPermission (key) {
  return ({ 'student-city-home': 'CASE_VIEW', 'student-city-run': 'EXPERIMENT_VIEW', 'student-policy-home': 'EXPERIMENT_VIEW', 'student-policy-analysis': 'EXPERIMENT_VIEW', 'student-reports': 'REPORT_VIEW', 'student-notifications': 'NOTIFICATION_VIEW', 'student-role-guide': 'ROLE_GUIDE_VIEW',
    'city-home': 'CASE_VIEW', 'city-custom': 'CASE_VIEW', 'city-maps': 'MAP_VIEW', 'city-score': 'REPORT_VIEW', 'policy-library': 'CASE_VIEW', 'policy-custom': 'CASE_VIEW', 'policy-tasks': 'EXPERIMENT_VIEW', 'policy-score': 'REPORT_VIEW', 'policy-assist': 'ROLE_GUIDE_VIEW', 'policy-home': 'CASE_VIEW',
    'admin-users': 'USER_VIEW', 'admin-classes': 'CLASS_VIEW', 'admin-experiments': 'EXPERIMENT_VIEW', 'admin-monitor': 'TASK_MONITOR', 'admin-role-permissions': 'PLATFORM_ROLE_MANAGE', 'system-logs': 'LOG_VIEW', 'system-backups': 'BACKUP_MANAGE', 'personal-notifications': 'NOTIFICATION_VIEW' })[key]
}
